<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-sushi',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components mt-8">
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="xl:text-lg text-nandor"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                            class="inline-flex"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="xl:text-lg text-nandor"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Content
                                        .text
                                "
                            ></span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage2
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card break-inside-avoid">
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Content
                                        .text
                                "
                            ></span>
                            <!-- <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Title.text
                                "
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        
                        <div>
                            <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Faire simple avec Ap’Hy'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage3
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
